'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports['default'] = function (props) {
	var valueLink = props.valueLink;

	var value = valueLink !== undefined ? valueLink.value : null;
	var handleChange = valueLink !== undefined ? function (e) {
		valueLink.value = e.target.value;
	} : null;

	return _react2['default'].createElement(
		'label',
		null,
		props.label,
		_react2['default'].createElement('input', { type: 'text', defaultValue: props.value, value: value, placeholder: props.placeholder,
			onChange: handleChange })
	);
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/TextBoxInput.js
 ** module id = 2226
 ** module chunks = 0
 **/